import React, { ReactElement } from 'react'
import { PageSeo } from '@/components/NextSeo/PageSeo'
import { UiLayoutConstant } from '@/globals/uiLayoutConstant'
import { BasePageProps } from '@/globals/pages.types'
import { CourseConfigType } from 'common/src/courseConfig'
import { GetStaticProps } from 'next'
import { UpdatesPage } from '@/components/UpdatesPage/UpdatesPage'

// TODO: Should gather the necessary data to populate this page via some kind of config
export const getStaticProps = (async (_context) => {
    return { props: { courseConfigType: CourseConfigType.fsaHealth } }
}) satisfies GetStaticProps<BasePageProps>

const Page = (_props: BasePageProps): ReactElement => {
    return (
        <>
            <PageSeo
                title={'Product updates and new features'}
                description={
                    'Everything new at Just Enough Prep: Eupheus conversations, whole-quiz and Excel autograding, notecard lessons, formula sheets and more — newest first.'
                }
                canonicalPath={UiLayoutConstant.UPDATES_PAGE}
            />
            <UpdatesPage isLoggedIn={false} />
        </>
    )
}

Page.isStatic = true

export default Page
